import { formatCustomDate } from "../services/dateService";

export const tableASelfAppraisalBurnData = {
  columns: [
    { field: "employee", header: "Empleado", columnWidth: "350px" },
    { field: "position", header: "Cargo", columnWidth: "300px" },
    {
      field: "actionButtons",
      header: "",
      columnType: "actionSelfApraisalButtonsColumn"
    }
  ],
  data: [
    {
      id: "0",
      position: "Gerente",
      employee: "Lucas Rodriguez"
    }
  ]
};

export const tableBSelfAppraisalBurnData = {
  columns: [
    { field: "employee", header: "Empleados", columnWidth: "250px" },
    { field: "position", header: "Cargo", columnWidth: "180px" },
    { field: "area", header: "Procesos", columnWidth: "190px" },
    {
      field: "actionButtons",
      header: "",
      columnType: "actionSelfApraisalButtonsColumn"
    }
  ],
  data: [
    {
      id: "0",
      employee: "Juan Perez Díaz",
      position: "Visitador",
      level: "Senior",
      area: "Administración"
    },
    {
      id: "1",
      code: "Lucía Guiterrez",
      employee: "Gerente",
      position: "Sub Gerente",
      level: "Semi Senior",
      area: "Ventas"
    },
    {
      id: "2",
      employee: "Manuel Arana",
      position: "Sub Gerente",
      level: "Senior",
      area: "Administración"
    },
    {
      id: "3",
      employee: "Pedro Lopez",
      position: "Visitador",
      level: "Semi Senior",
      area: "Ventas"
    }
  ]
};

export const superior_rol_A_BurnData = {
  columns: [
    { field: "report", header: "Informe" },
    { field: "actionButtons", header: "", columnType: "actionButtons" }
  ],
  data: [
    {
      id: "0",
      report: "Informe 360 grados - Lucas Rodriguez"
    }
  ]
};

export const superior_rol_B_BurnData = {
  columns: [
    {
      field: "expander",
      header: "",
      columnType: "expander"
    },
    { field: "nameActivity", header: "Actividad", columnWidth: "450px" },
    { field: "competencyName", header: "Competencia", columnWidth: "150px" },
    { field: "priorityText", header: "Prioridad", columnWidth: "200px" },
    { field: "actionButtons", header: "", columnType: "actionButtons" }
  ]
};

export const superior_rol_C_BurnData = {
  columns: [
    { field: "employee", header: "Empleados" },
    { field: "position", header: "Cargo" },
    {
      field: "comment",
      header: "Comentarios"
    },
    { field: "actionButtons", header: "", columnType: "actionButtons" }
  ],
  data: [
    {
      id: "0",
      employee: "Nazareno Aguirre",
      charge: "Director",
      comments:
        "1 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "1",
      employee: "Florencia Rios",
      charge: "Gerente",
      comments:
        " 2Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "2",
      employee: "Juan Perez",
      charge: "Gerente",
      comments:
        "3Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "3",
      employee: "Maria Lopez",
      charge: "Coordinador",
      comments:
        "4Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "4",
      employee: "Andres Forero",
      charge: "Director",
      comments:
        "5Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "5",
      employee: "Laura Soto",
      charge: "Gerente",
      comments:
        "6Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "6",
      employee: "Nazareno Aguirre",
      charge: "Director",
      comments:
        "7 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "7",
      employee: "Florencia Rios",
      charge: "Gerente",
      comments:
        " 8Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "8",
      employee: "Juan Perez",
      charge: "Gerente",
      comments:
        "9Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "9",
      employee: "Maria Lopez",
      charge: "Coordinador",
      comments:
        "10Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "10",
      employee: "Andres Forero",
      charge: "Director",
      comments:
        "11Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "11",
      employee: "Laura Soto",
      charge: "Gerente",
      comments:
        "12Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "12",
      employee: "Andres Forero",
      charge: "Director",
      comments:
        "13Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    },
    {
      id: "13",
      employee: "Laura Soto",
      charge: "Gerente",
      comments:
        "14Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis."
    }
  ]
};
export const getModeText = (value, modeOptions = []) => {
  const normalizedValue = Number(value);
  const match = modeOptions.find(
    (option) => Number(option?.value) === normalizedValue
  );
  return match?.name || "";
};

export const dasboardBioMedicalBurnData = (isSmallScreen) => ({
  columns: [
    {
      field: "serie_id",
      header: "",
      columnType: "hide"
    },
    {
      field: "serie_name",
      header: "Nro. de Serie",
      columnType: "custom-frozen",
      borderRadius: "left",
      render: (rowData) => {
        return (
          <p className="table-default-column w-max-content">
            {rowData.serie_name ? rowData.serie_name : ""}
          </p>
        );
      }
    },
    {
      field: "name",
      header: "Nombre del Equipo",
      columnType: isSmallScreen ? "" : "custom-frozen",
      render: (rowData) => (
        <p className="table-default-column">
          {rowData.name ? rowData.name : ""}
        </p>
      )
    },
    { field: "brand_id", header: "brand_id", columnType: "hide" },
    { field: "brand_name", header: "Marca" },
    { field: "model", header: "Modelo" },
    {
      field: "health_record_or_marketing_permit_text",
      header: "Permiso de Comercialización o Registro Sanitario"
    },
    { field: "institution_id", header: "institution_id", columnType: "hide" },
    { field: "institution_name", header: "Institución" },
    {
      field: "current_location_id",
      header: "Ubicación id",
      columnType: "hide"
    },
    { field: "current_location_name", header: "Ubicación" },

    {
      field: "import_date",
      header: "Fecha de importación",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {(rowData.creation_date)}
        </p>
      ),
      columnWidth: "115px"
    },
    { field: "aaaa", header: "Nombre de fabricante" },

    {
      field: "state_id",
      header: "Modalidad",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">{getModeText(rowData.state_id)}</p>
      )
    },

    { field: "actionButtons", columnType: "actionButtons" }
  ],
  data: [
    {
      item: "item",
      marketingPermit: "marketingPermit",
      institution: "institution",
      brand: "brand",
      model: "model",
      serieNumber: "serieNumber",
      importer: "importer",
      location: "location"
    }
  ]
});

export const MarketingPromotionManagementBurnData = [
  {
    id: 1,
    name: "Cumplimiento Real Vs Cuota",
    reportPbiId: 9999,
    analysis: null,
    commitment: null,
    reportMonthYear: null
  },
  {
    id: 2,
    name: "Crecimiento 2024/2023",
    reportPbiId: null,
    analysis: null,
    commitment: null,
    reportMonthYear: null
  },
  {
    id: 3,
    name: "Relacion Ventas/Enrolamiento Pacientes",
    reportPbiId: 1,
    analysis: "Test",
    commitment: "test",
    reportMonthYear: "2024-06"
  },
  {
    id: 4,
    name: "Relación médicos formuladores/Panel médico",
    reportPbiId: null,
    analysis: null,
    commitment: null,
    reportMonthYear: null
  },
  {
    id: 5,
    name: "Enrolamiento/Pacientes según ventas",
    reportPbiId: null,
    analysis: null,
    commitment: null,
    reportMonthYear: null
  },
  {
    id: 6,
    name: "Planeacion Mes Vs Mes",
    reportPbiId: null,
    analysis: null,
    commitment: null,
    reportMonthYear: null
  }
];

export const surveyBurnData = [
  {
    competencyId: 1,
    competencyName: "Desarrollo de negocios",
    competencyDescription:
      "Crea y mantiene la visión del negocio a través de un pensamiento y actitud emprendedores. Desarrolla estrategias innovadoras que fortalecen la competitividad y sostenibilidad; se anticipa a los obstáculos y asume riesgos con responsabilidad para incrementar el valor agregado y la rentabilidad del negocio.",
    questionId: 1,
    question:
      "1. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, ¿quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?",
    options: [
      { text: "1", value: 1 },
      { text: "2", value: 2 },
      { text: "3", value: 3 },
      { text: "4", value: 4 },
      { text: "5", value: 5 },
      { text: "6", value: 6 },
      { text: "7", value: 7 },
      { text: "8", value: 8 },
      { text: "9", value: 9 },
      { text: "10", value: 10 }
    ]
  },
  {
    competencyId: 1,
    competencyName: "Desarrollo de negocios",
    competencyDescription:
      "Crea y mantiene la visión del negocio a través de un pensamiento y actitud emprendedores. Desarrolla estrategias innovadoras que fortalecen la competitividad y sostenibilidad; se anticipa a los obstáculos y asume riesgos con responsabilidad para incrementar el valor agregado y la rentabilidad del negocio.",

    questionId: 2,
    question:
      "2. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, ¿quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?",
    options: [
      { text: "1", value: 1 },
      { text: "2", value: 2 },
      { text: "3", value: 3 },
      { text: "4", value: 4 },
      { text: "5", value: 5 },
      { text: "6", value: 6 },
      { text: "7", value: 7 },
      { text: "8", value: 8 },
      { text: "9", value: 9 },
      { text: "10", value: 10 }
    ]
  },
  {
    competencyId: 1,
    competencyName: "Desarrollo de negocios",
    competencyDescription:
      "Crea y mantiene la visión del negocio a través de un pensamiento y actitud emprendedores. Desarrolla estrategias innovadoras que fortalecen la competitividad y sostenibilidad; se anticipa a los obstáculos y asume riesgos con responsabilidad para incrementar el valor agregado y la rentabilidad del negocio.",

    questionId: 3,
    question:
      "3. Lorem i3nsectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, ¿quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?",
    options: [
      { text: "1", value: 1 },
      { text: "2", value: 2 },
      { text: "3", value: 3 },
      { text: "4", value: 4 },
      { text: "5", value: 5 },
      { text: "6", value: 6 },
      { text: "7", value: 7 },
      { text: "8", value: 8 },
      { text: "9", value: 9 },
      { text: "10", value: 10 }
    ]
  },
  {
    competencyId: 1,
    competencyName: "Desarrollo de negocios",
    competencyDescription:
      "Crea y mantiene la visión del negocio a través de un pensamiento y actitud emprendedores. Desarrolla estrategias innovadoras que fortalecen la competitividad y sostenibilidad; se anticipa a los obstáculos y asume riesgos con responsabilidad para incrementar el valor agregado y la rentabilidad del negocio.",
    questionId: 4,
    question:
      "4. Lorem4 consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, ¿quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?",
    options: [
      { text: "1", value: 1 },
      { text: "2", value: 2 },
      { text: "3", value: 3 },
      { text: "4", value: 4 },
      { text: "5", value: 5 },
      { text: "6", value: 6 },
      { text: "7", value: 7 },
      { text: "8", value: 8 },
      { text: "9", value: 9 },
      { text: "10", value: 10 }
    ]
  },
  {
    questionId: 5,
    question:
      "5. Lo5tetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, ¿quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?",
    options: [
      { text: "1", value: 1 },
      { text: "2", value: 2 },
      { text: "3", value: 3 },
      { text: "4", value: 4 },
      { text: "5", value: 5 },
      { text: "6", value: 6 },
      { text: "7", value: 7 },
      { text: "8", value: 8 },
      { text: "9", value: 9 },
      { text: "10", value: 10 }
    ]
  },
  {
    questionId: 6,
    question:
      "6. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, ¿quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?",
    options: [
      { text: "1", value: 1 },
      { text: "2", value: 2 },
      { text: "3", value: 3 },
      { text: "4", value: 4 },
      { text: "5", value: 5 },
      { text: "6", value: 6 },
      { text: "7", value: 7 },
      { text: "8", value: 8 },
      { text: "9", value: 9 },
      { text: "10", value: 10 }
    ]
  },
  {
    questionId: 7,
    question:
      "7. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, ¿quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat?",
    options: [
      { text: "1", value: 1 },
      { text: "2", value: 2 },
      { text: "3", value: 3 },
      { text: "4", value: 4 },
      { text: "5", value: 5 },
      { text: "6", value: 6 },
      { text: "7", value: 7 },
      { text: "8", value: 8 },
      { text: "9", value: 9 },
      { text: "10", value: 10 }
    ]
  }
];

export const paiBurnData = {
  //tabla pai
  tableBurnData: [
    {
      id: "0",
      name: "Doctor Orduz",
      comment:
        "sum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis.",
      date: "10/01/2024"
    },
    {
      id: "1",
      name: "Don Humberto",
      comment:
        "ctetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis.",
      date: "13/02/2024"
    },
    {
      id: "2",
      name: "Juan Perez",
      comment:
        "vamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis.",
      date: "20/06/2024"
    },
    {
      id: "3",
      name: "Don Humberto",
      comment:
        "r sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis.",
      date: "24/07/2024"
    }
  ],
  competencyData: [
    {
      //datos competencia
      competenciaId: 1,
      competencyName: "Desarrollo de negocios",
      description:
        "des1 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      goals:
        "go Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      firstResultIndicator:
        "firstResultIndicatorectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      firstAction: "orem ipsum dolor sit amet, consectetur a",
      secondResultIndicator:
        "secondResultIndicator orem ipsum dolor sit amet, consectetur a",
      secondAction:
        "12 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      followUp: "Doctor Orduz, Don Humberto",
      startDate: "11/11/2011",
      followUpDate: "22/11/2011",
      lastFollowUp: "23/11/2011"
    },
    {
      //datos competencia
      competencyId: 2,
      competencyName: "Desarrollo de negocios",
      description:
        "des1 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      //tab pai
      goals:
        "go Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      firstResultIndicator:
        "firstResultIndicatorectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      firstAction: "orem ipsum dolor sit amet, consectetur a",
      secondResultIndicator:
        "secondResultIndicator orem ipsum dolor sit amet, consectetur a",
      secondAction:
        "12 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      followUpBy: "Doctor Orduz, Don Humberto",
      starDate: "11/11/2011",
      updateDate: "22/11/2011",
      endDate: "23/11/2011",

      //tabla pai
      tableBurnData: [
        {
          id: "0",
          name: "Doctor Orduz",
          comment:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis.",
          date: "10/04/2024"
        },
        {
          id: "1",
          name: "Don Humberto",
          comment:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis.",
          date: "13/04/2024"
        },
        {
          id: "2",
          name: "Juan Perez",
          comment:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis.",
          date: "20/04/2024"
        },
        {
          id: "3",
          name: "Don Humberto",
          comment:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac egestas tortor. Pellentesque in urna odio. Aenean posuere, diam a feugiat pharetra, diam erat sagittis turpis.",
          date: "24/04/2024"
        }
      ]
    }
  ]
};

export const competencesReport360Specific = [
  { id: 1, name: "Desarrollo de negocios" },
  { id: 2, name: "Pensamiento estratégicos" },
  { id: 3, name: "Liderazgo" },
  { id: 4, name: "Negociación efectiva" }
];

export const competencesReport360Organizational = [
  { id: 16, name: "Calidad, Salud ocupacional y mejoramiento continuo" },
  { id: 17, name: "Orientacion al logro" },
  { id: 18, name: "Trabajo en equipo" },
  { id: 19, name: "Disciplina" }
];

export const total360 = [
  { id: 1, name: "Par" },
  { id: 2, name: "Jefe" },
  { id: 3, name: "Cliente" },
  { id: 4, name: "Autoevaluador" },
  { id: 5, name: "Total" }
];

export const yesNoSelect = [
  { value: 0, name: "No" },
  { value: 1, name: "Si" }
];

export const base64Burn =
  "data:image/png;base64,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";

export const modeOptions = [
  { name: "Apoyo tecnológico", value: 1 },
  { name: "Venta", value: 2 },
  { name: "Demostración", value: 3 },
  { name: "Backup", value: 4 },
  { name: "Asignado", value: 5 },
  { name: "Aprobado", value: 6 }
];
